import gxv3350 from './default.gxv3350';
import gxv3370 from './default.gxv3370';
import gxv3380 from './default.gxv3380';
import gxv3450 from './default.gxv3450';
import gxv3470 from './default.gxv3470';
import gxv3480 from './default.gxv3480';
import gac2570 from './default.gac2570';

const DEFAULTS = {
  gxv3350,
  gxv3370,
  gxv3380,
  gxv3450,
  gxv3470,
  gxv3480,
  gac2570,
};

export default DEFAULTS;

export const getDefaultParams = (product: Product) => {
  if (!product) return {};
  return DEFAULTS[product];
};
